<template>
  <div v-cloak class="h-100">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import progressHolder from './config/progress/progress.holder'

  export default {
    metaInfo: {
      title: 'Administration',
      titleTemplate: '%s | Amio'
    },
    created() {
      const progress = progressHolder.setProgress(this.$Progress)

      this.$router.beforeEach((to, from, next) => {
        log.debug(`router changes from ${from.path} to ${to.path}`)
        progress.start()
        next()
      })

      this.$router.afterEach((to, from) => {
        log.debug(`router changed from ${from.path} to ${to.path}`)
        progress.finish()
      })
    }
  }
</script>

<style>
  [v-cloak] {
    display: none;
  }
</style>
